<template>
    <div :class="`section ${grey === 'true' ? 'grey-card' : ''}`">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col cols="12" class="px-10 text-center">
                    <h2 class="text-h5">{{ msg }}</h2>
                    <div>
                        <v-btn
                        class="btn-primary white--text rounded-lg mt-8 mr-5"
                        elevation="0"
                        :ripple="false"
                        href="https://go.yabbr.io/#/signup"
                        large>
                        Request a Demo
                        </v-btn>
                        
                        <v-btn
                        class="btn-primary--outline rounded-lg mt-8"
                        outlined
                        large
                        :ripple="false"
                        @click="openChat">
                        Contact us
                        </v-btn>
                    </div>
                    
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'RequestDemo',
    props: [
        'msg',
        'grey'
  ],
  methods: {
    openChat() {
      if (window.yabbr) {
        window.openYabbrWidget();
      } else {
        console.error('Yabbr is not loaded yet.');
      }
    },
  },
}
</script>

<style lang="scss">

</style>